import { DateColumnFormat } from './ColumnFormatters/DateColumnFormat';
import { DetailColumnFormat } from './ColumnFormatters/DetailColumnFormat';
import { DetailSearchColumn } from './ColumnFormatters/DetailSearchColumn';

///-------------------------MIEMBROS-----------------------------
export const columnsMember = [
	{
		dataField: 'nombre',
		text: 'Nombre',
		style: { maxWidth: '250px' },
		headerAlign: 'left',
	},
	{
		dataField: 'cargo',
		text: 'Cargo',
		headerAlign: 'left',
	},
];

//----------------PreviousSessions----------------------------------------
export const columnsPreviousSessions = (onOrderOTDay) => [
	{
		dataField: 'fecha',
		text: 'Fecha',
		classes: ' text-center',
	},
	{
		dataField: 'numero_sesion',
		text: 'Sesión',
		style: { maxWidth: '250px', textAlign: 'center' },
	},
	{
		dataField: 'id',
		text: 'Ver Detalle',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: DetailColumnFormat,
		formatExtraData: {
			onOrderOTDay,
		},
	},
];

///-----------------UpcomingSessions--------------------------------------

export const columnsUpcomingSessions = (onOrderOTDay) => [
	{
		dataField: 'hourAndDate',
		text: 'Fecha y Hora',
		formatter: DateColumnFormat,
		classes: ' text-center',
	},
	{
		dataField: 'organAndSession',
		text: 'Consejo',
		classes: ' text-center',
	},
	{
		dataField: 'id',
		text: 'Ver Detalle',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: DetailColumnFormat,
		formatExtraData: {
			onOrderOTDay,
		},
	},
];

export const defaultSessions = {
	id: '',
	hourAndDate: '',
	organAndSession: '',
};

///////SEARCH
export const filter_form = (
	organs = [],
	sessions = [],
	institutions = [],
	onConfirmFilter,
	onClear
) => [
	{
		label: 'Introduce una palabra',
		name: 'pClave',
		type: 'text',
		column: 3,
	},
	{
		label: 'Órgano Colegiado',
		name: 'organ',
		type: 'dropdown',
		options: [...organs],
		column: 3,
	},
	{
		label: 'Número de Sesión',
		name: 'session',
		type: 'dropdown',
		options: [...sessions],
		column: 3,
	},
	{
		label: 'Área de Asignación',
		name: 'area',
		type: 'dropdown',
		options: [...institutions],
		column: 3,
	},
	{
		label: 'Fecha de Cumplimiento',
		name: 'date',
		type: 'date',
		column: 3,
	},
	{
		label: 'Estatus',
		name: 'status',
		type: 'dropdown',
		options: [
			{ value: 'PE', text: 'Pendiente' },
			{ value: 'AS', text: 'Asignada' },
			{ value: 'EP', text: 'En Proceso' },
			{ value: 'AT', text: 'Atendida' },
		],
		column: 3,
	},
	{
		type: 'inner-column',
		column: 2,
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'light-primary',
		type: 'button',
		onClick: onClear,
		column: 2,
		style: { width: '100%' },
	},
	{
		label: 'Consultar',
		name: 'Consultar',
		color: 'primary',
		type: 'button',
		onClick: onConfirmFilter,
		column: 2,
		style: { width: '100%' },
	},
];

export const columns = (onEye, arrayOrgan, accessAll) => [
	{
		dataField: 'resolucionId',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: DetailSearchColumn,
		formatExtraData: {
			onEye,
			arrayOrgan,
			accessAll,
		},
	},
	{
		dataField: 'resolucion',
		text: 'Resolución',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'textoResolucion',
		text: 'Texto',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'organoColegiado',
		text: 'Órgano Colegiado',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'numeroSesion',
		text: 'Número de Sesión',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'dateSesion',
		text: 'Fecha de Sesión',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'dateCompliance',
		text: 'Fecha de Cmpto',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'responsable',
		text: 'Responsable',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'areaResponsable',
		text: 'Área Responsable',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'acompaniante',
		text: 'Acompañante',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'areaAcompaniante',
		text: 'Área Acompañante',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'documentos',
		text: 'Documentos',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'status',
		text: 'Estatus',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
];

export const defaultFilter = {
	pClave: '',
	organ: '',
	session: '',
	area: '',
	date: null,
	status: '',
};
